import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import RouteService from '../../../services/RouteService';
import globalTranslations from '../../../i18n/globalTranslations';
import LinkType from '../../../types/LinkType';
import Paths from '../../../types/Paths';
import HeaderNavLink from '../HeaderNavLink';

@observer
export class NavigationWishListButton extends Component {
  render() {
    return (
      <HeaderNavLink
        surface="top"
        to={this.props.routeService.getPath(Paths.WishList)}
        type={LinkType.INTERNAL_LINK}
      >
        <FormattedMessage {...globalTranslations.wishListTitle} />
      </HeaderNavLink>
    );
  }
}

NavigationWishListButton.propTypes = {
  routeService: PropTypes.instanceOf(RouteService).isRequired,
};

export default inject('routeService')(NavigationWishListButton);
